import React, {FC} from "react"

import {Body} from "@irati/ui/src/Typography"
import {CompanyValue} from "@irati/types"
import {useTheme} from "@irati/ui/src/global/useTheme"

import {Position, ImageWrapper, Image, Wrapper} from "../styled"
import getRankingColor from "../getRankingColor"

interface Props {
  value: CompanyValue
  ranking: number
}

const CompanyValueSection: FC<Props> = ({value, ranking}) => {
  const theme = useTheme()

  return (
    <div>
      <Wrapper size={50}>
        <Position size={22} left="-10px" justifyContent="center" alignItems="center" bgColor={getRankingColor(ranking, theme)}>
          <Body color={theme.colors.greys.white}>#{ranking}</Body>
        </Position>
        <ImageWrapper size={50}>
          <Image src={value.icon.href} height="50px" width="50px" />
        </ImageWrapper>
      </Wrapper>
      <Body textAlign="center">{value.name}</Body>
    </div>
  )
}

export default CompanyValueSection
